import { DocumentButtonComponentProps, DocumentButtons } from "PFApp/components/document_buttons";
import { Button } from "PFComponents/button/button";
import { fetchSkillsFrameworksExportDataCsv } from "PFCore/services/skills_frameworks/fetch_skills_frameworks_export_data";
import React from "react";
import { useTranslation } from "react-i18next";

const ExportCsvButton = ({ onClick }: DocumentButtonComponentProps) => {
  const { t } = useTranslation("skillsFrameworks");

  return <Button onClick={onClick} kind="secondary" icon="export" text={t("list.export")} />;
};

export const ExportFrameworksButton = () => (
  <DocumentButtons
    generateDocument={fetchSkillsFrameworksExportDataCsv}
    exportOptions={["csv"]}
    buttonComponent={ExportCsvButton}
    hideLabel
  />
);
